const {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest,
} = require("./http-helper");
const api = "levels";

const createLevel = ({ name, institution, hidden, priority }) => {
	return new Promise((resolve, reject) => {
		postRequest(
			api,
			{ name, institution, hidden, priority },
			resolve,
			reject,
			true
		);
	});
};

const deleteLevel = (id) => {
	return new Promise((resolve, reject) => {
		deleteRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const getLevelDetails = (id) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const getLevels = (institution) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}?institution=${institution}`, resolve, reject, true);
	});
};

const updateLevel = ({ _id, name, institution, hidden, priority }) => {
	return new Promise((resolve, reject) => {
		putRequest(
			`${api}/${_id}`,
			{ name, institution, hidden, priority },
			resolve,
			reject,
			true
		);
	});
};

const importLevels = (importData) => {
	return new Promise((resolve, reject) => {
		postRequest(
			`${api}/import`,
			{ importLevels: importData },
			resolve,
			reject,
			true
		);
	});
};

module.exports = {
	createLevel,
	deleteLevel,
	getLevelDetails,
	getLevels,
	updateLevel,
	importLevels,
};
